// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"LandingPage_Arrow__3CFCF","ArrowTip":"LandingPage_ArrowTip__7LE0J"};